<template>
  <div id="cardrule">
    <div class="header flex-between">
      <div class="header-text">
        <h1>会员卡号规则设置</h1>
      </div>

      <div class="header-button">
        <el-button icon="el-icon-edit-outline" v-if="disabled" plain @click="modifyHandel"
          >修改</el-button
        >
        <el-button icon="el-icon-edit-outline" v-if="disabled" plain @click="saveHandel">保存</el-button>
      </div>
    </div>

    <el-card shadow="never">
      <div style="width: 30%">
        <el-form
          ref="formRef"
          :model="form"
          label-width="120px"
          size="small"
          :rules="rulesForm"
          :hide-required-asterisk="true"
          :disabled="isDisabled"
        >
          <el-form-item label="卡号流水长度" >
            <el-input v-model="form.cardSNLen" 
            type="text" onkeyup="value=value.replace(/[^\d]/g,'')"
            @input.native	="inputValue"
            ></el-input>
          </el-form-item>
          <el-form-item label="流水起始值" >
            <el-input v-model="form.cardMinSN" type="text" onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
          </el-form-item>
          <el-form-item label="卡号前缀"  >
            <el-input v-model="form.prefixCardNo" type="text" onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
          </el-form-item>
          <el-form-item label="卡号后缀">
            <el-input v-model="form.suffixCardNo" type="text" onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
          </el-form-item>
          <el-form-item label="随机位数" >
            <el-input v-model="form.randomLen" type="text" onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getcpyNo } from "@/utils/auth";
import { tCardnoruleApi, selectByCpyNOApi } from "@/api/user";
export default {
  name: "centre",
  data() {
    return {
      isDisabled:true,
      form: {
        cardMinSN: "",
        cardSNLen: "",
        cpyNO: getcpyNo(),
        currCardSN: "",
        prefixCardNo: "",
        randomLen: "",
        suffixCardNo: "",
      },
      rulesForm: {
        cardSNLen: [
          { required: true, message: "请输入卡号流水长度", trigger: "blur" },
          { min: 1, max:3,message: "卡号最长不能超过15位", trigger: "blur" },
        ],
        cardMinSN: [
          { required: true, message: "流水起始值不能为空", trigger: "blur" },
          { min: 1,max:15, message: "长度在最少1位", trigger: "blur" },
        ],
        prefixCardNo: [
          { required: true, message: "请输入卡号前缀", trigger: "blur" },
          { min: 1, message: "长度在至少1位", trigger: "blur" },
        ],
        suffixCardNo: [
          { required: true, message: "请输入卡号后缀", trigger: "blur" },
          { min: 1, message: "长度在至少1位", trigger: "blur" },
        ],
        randomLen: [
          { required: true, message: "请输入随机数", trigger: "blur" },
          { min: 1, message: "长度在至少1位", trigger: "blur" },
        ],
      },
      disabled:false
    };
  },
  created() {
    this.memberList();
    let CardRule = JSON.parse(localStorage.getItem("CardRule"));
    if(CardRule.length>0){
      this.disabled=true;
    }
  },
  methods: {
    async memberList() {
      await selectByCpyNOApi({
        cpyNO: getcpyNo(),
      }).then((res) => {
        if(res.data !== null){
          console.log(111)
        this.form = res.data;
      }
        // this.form = res.data;
      });
    },
    // 修改
    modifyHandel() {
      this.isDisabled=false  
    },
    saveHandel(){
      this.$refs.formRef.validate( async(valid)=>{
        if(valid){
            await tCardnoruleApi(this.form).then((res) => {
              if (res.success !==true){
                return this.$message.error("修改参数不完整!");
              }
              this.inputValue();
              return this.$message.success("修改成功!");
            });
        } else {
            return false;
          }
      })  
    },
    inputValue(){
      selectByCpyNOApi().then(res=>{
        // console.log(res)
        if(res.data !== null){
          this.form=res.data
        }
      })
    }
  },
};
</script>
<style lang="scss" scoped>
#cardrule {
  // height:1000px
}
.header {
  .header-text {
    width: 20rem;
    height: 50px;
    margin-top: 20px;
    color: #76734f;
  }
  .card-pagination {
    height: 50px;
  }
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}

// input框的背景色和取消圆角

/deep/input {
  border-radius: 0 !important;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}
</style>
